<template>

    <div class="container" style="min-height: 600px;">

        <div v-if="loading">
      <hollow-dots-spinner class="loading_card_spinner" :animation-duration="1000" :dot-size="35" :dots-num="3"
        color="var(--primary-color)" />

    </div>

    <div v-else>

        <div class="row checkout_page" style="margin-top: 5%;">
            <div class="col-lg-8 col-md-8 col-12" style="margin-top: 5%;">

                <h2 class="title_h2">{{ $t('Order Details') }}</h2>
                <hr id="title_hr">
                <div class="row">
                    <div class="mb-3  col-lg-6 col-md-12 col-12 shipping_address_delivry"
                        style="display: block!important">

                        <input type="text" v-model="user_name" id="name" :placeholder="$t('name') + '*'"
                            class="form-control ">
                    </div>

                    <div class="mb-3   col-lg-6 col-md-12 col-12 shipping_address_delivry"
                        style="display: block!important">

                        <input type="email" v-model="email" id="email" :placeholder="$t('email')" class="form-control ">
                    </div>
                    <div class="w-100"></div>

                    <div class="mb-3  col-lg-6 col-md-12 col-12 shipping_address_delivry"
                        style="display: block!important">

                        <select id="phone_code" name="phone_code" class="form-select ">
                            <option v-for="(item, index) in this.market_countries" :key="index">{{ item.code }}({{
                                item.name }})</option>
                        </select>
                    </div>

                    <div class="mb-3  col-lg-6 col-md-12 col-12 shipping_address_delivry"
                        style="display: block!important">

                        <input autocomplete="" v-model="phone" required :minlength=$store.state.country_length
                            :maxlength=$store.state.country_length :placeholder="$t('phone') + '*'"
                            class="form-control " id="phone">
                    </div>


                    <div id="delivery_methods">
                        <h2 class="title_h2" id="delivery">{{ $t('Shipping Method') }}</h2>
                        <hr id="title_hr">
                        <div v-for="(item, index) in this.DBitems.delivery_type.types" :key="index">
                            <label :for="'delivery' + item.id">
                                <input type="radio" name="delivery_option" class=" custom-radio "
                                    :id="'delivery' + item.id" :value="item.id" @click="selectDeliveryTypeId(item.id)">
                                <span class="checkmark"></span>
                                {{ item.type }}

                            </label>
                            <br>
                        </div>
                    </div>

                    <br>
                    <br>


                    <div v-if="showAddress">
                        <h2 class="title_h2" id="delivery">
                            {{ $t('Delivery Address') }}
                        </h2>




                        <div class="w-100"></div>
                        <div class="mb-3   col-lg-12 col-md-12 col-12 shipping_address_delivry div_state"
                            style="display: block!important">

                            <v-select v-model="country" :reduce="(option) => option.id" :options="countries"
                                label="city" :placeholder="$t('country')" class="form-select " id="country">
                            </v-select>
                        </div>

                        <div class="mb-3   col-lg-12 col-md-12 col-12 shipping_address_delivry div_state"
                            style="display: block!important">

                            <v-select v-model="city" :reduce="(option) => option.id" :options="cities" label="city"
                                :placeholder="$t('city')" class="form-select " id="city">
                            </v-select>
                        </div>


                        <div class="w-100"></div>
                        <div class="mb-3   col-lg-12 col-md-12 col-12 div_city_id shipping_address_delivry"
                            style="display: block!important">
                            <v-select v-model="region" :reduce="(option) => option.id" :options="regions" label="city"
                                :placeholder="$t('region')" class="form-select" id="region">
                            </v-select>
                        </div>
                      
                        <div class="w-100"></div>

                        <div id="check">
                            <div class="mb-3  col-lg-12 div_street shipping_address_delivry"
                                style="display: block!important">
                                <input type="text" :placeholder="$t('street')" maxlength="255" id="street"
                                    v-model="street" class="form-control ">
                            </div>
                            <div class="w-100"></div>


                            <div class="mb-3  col-lg-12 div_street2 shipping_address_delivry"
                                style="display: block!important">
                                <input type="text" :placeholder="$t('building')" maxlength="255" v-model="building"
                                    id="building" class="form-control ">
                            </div>
                            <div class="w-100"></div>


                            <div class="mb-3  col-lg-12 div_street3 shipping_address_delivry"
                                style="display: block!important">
                                <textarea type="text" name="street3" v-model="other_details" class="form-control "
                                    :placeholde="$t('OtherDetails')">
                                    </textarea>
                            </div>
                        </div>
                    </div>



                    <!-- <div class="mb-3 shipping_address_delivry  col-lg-12" style="display: block!important">
                        <label class="form-check-label color-black font-weight-normal" for="call_receiver">
                            <input id="call_receiver" type="checkbox" name="call_receiver"
                                onclick="closePopup('check')">
                            <span class="checkmark"></span>
                            Call the receiver I don't know the delivery address
                        </label>
                    </div> -->
                    <div class="w-100"></div>


                </div>









                <div id="payment_methods" style="display:none">
                    <h2 class="title_h2" id="payment">{{ $t('Payment Method') }}</h2>
                    <hr id="title_hr">
                    <div v-for="(item, index) in this.DBitems.payment_types.types" :key="index">
                        <label :for="'payment' + item.id" class="payment_radio ">
                            <input type="radio" name="payment_option" class="payment_option custom-radio" :id="'payment' + item.id"
                                :value="item.id" @click="selectPaymentTypeId(item.id)">
                            <span class="checkmark"></span>
                            {{ item.type }}

                        </label>
                        <br>
                    </div>


                    <br>
                    <br>

                </div>



                <div style="direction: rtl;" id="payment_btn">


                    <button class="btn_cart_check" @click="show_payment">
                        <i class="fa fa-angle-right"></i>
                        {{ $t('Procced to payment') }}</button>
                </div>
                 <button v-if="loadingMethods" button class="btn_cart_check">
                                       <i class="fa fa-spinner fa-spin "></i>
                                  </button>
            </div>



            <div class="col-lg-4 col-md-4 col-12" id="col_cheakout">
                <!-- <div class="progress-container">

                    <button class="step d" @click="$router.push({
                        name: 'shoppingCart',
                        params: {
                            storeName: $store.storeName,
                            lang: $i18n.locale
                        },
                    });">

                        {{ $t('Review Order') }}


                    </button>



                    <button class="step " @click="show_delivery">
                        {{ $t('address') }}
                    </button>

                    <button class="step active " @click="show_payment">
                        {{ $t('Confirm Order') }}
                    </button>

                </div> -->

                <div class="card_checkout" style="min-height: 400px;height:auto">


                    <table class="table_products_confirm" style="margin-top: 6%;">

                        <tr>

                            <th>{{ $t('product') }} </th>
                            <th style="width: 40%;"></th>
                            <th>{{ $t('QT') }}</th>
                            <th>{{ $t('price') }}</th>


                        </tr>


                        <item_cart v-for="item in this.items" :key="item" :item-id="item"></item_cart>


                    </table>

                    <table class="table mb-0">
                        <tbody>
                            <tr id="empty">
                                <td class="col-md-2 col-3 border-0"></td>
                                <td class="col-md-2 col-3 border-0"></td>
                            </tr>
                            <tr id="order_total_untaxed">
                                <td class="text-start border-0" style="padding-bottom: 10px;">{{ $t('Subtotal') }}:</td>
                                <td class="text-xl-end border-0">
                                    <span class="monetary_field" style="white-space: nowrap;"><span
                                            class="oe_currency_value"> {{
                                                (PartialPrice * $store.state.rate).toFixed($store.state.digit_price)
                                            }}</span>&nbsp;{{ this.$store.state.UnitPrice }}</span>
                                </td>
                            </tr>

                            <tr v-if="this.discountPrice != 0" id="order_total_discount">
                                <td class="text-start border-0" style="padding-bottom: 30px;">{{ $t("discount") }} ({{
                                    discountPrice }} %):</td>
                                <td class="text-xl-end border-0">
                                    <span class="monetary_field" style="white-space: nowrap;"><span
                                            class="oe_currency_value"> {{ ((this.discountPrice * this.PartialPrice
                                                * $store.state.rate) / 100).toFixed($store.state.digit_price) }}
                                        </span>&nbsp;{{ this.$store.state.UnitPrice }}</span>
                                </td>
                            </tr>

                            <tr v-if="this.selectDeliveryType == 5" id="order_total_delivery">
                                <td class="text-start border-0" style="padding-bottom: 30px;">{{ $t("deliveryPrice") }}:
                                </td>
                                <td class="text-xl-end border-0">
                                    <span class="monetary_field" style="white-space: nowrap;"><span
                                            class="oe_currency_value"> {{
                                                (deliveryPrice * $store.state.rate).toFixed($store.state.digit_price) }} 
                                        </span>&nbsp;{{ this.$store.state.UnitPrice }}</span>
                                </td>
                            </tr>


                            <tr v-if="$store.state.tax != null" id="order_total_taxes">
                                <td class="text-start border-0" style="padding-bottom: 30px;">{{ $t("tax") }} ( {{
                                    $store.state.tax }}% ):</td>
                                <td class="text-xl-end border-0">
                                    <span class="monetary_field" style="white-space: nowrap;"><span
                                            class="oe_currency_value">{{
                                                (
                                                    ((this.$store.state.tax *
                                                        (this.PartialPrice -
                                                            (this.discountPrice * this.PartialPrice) / 100 +
                                                            this.deliveryPrice)) /
                                                        100) * $store.state.rate
                                                ).toFixed($store.state.digit_price)
                                            }}
                                        </span>&nbsp;{{ this.$store.state.UnitPrice }}</span>
                                </td>
                            </tr>
                            <tr id="order_total">
                                <td class="text-start border-top border-bottom-0">
                                    <span style="padding-left: 20px;">{{ $t('total') }}:</span>
                                </td>
                                <td class="text-xl-end border-top border-bottom-0">
                                    <span class="monetary_field"><span class="oe_currency_value">{{
                                        (totalPrice * $store.state.rate).toFixed($store.state.digit_price) }}
                                        </span>&nbsp;{{ this.$store.state.UnitPrice }}</span>
                                </td>
                            </tr>
                            <tr>


                            </tr>
                            <tr class="oe_website_sale_gift_card">
                                <td colspan="3" class="text-center text-xl-end border-0">
                                    <span class="">
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>


                </div>
            </div>
            <div style="direction: rtl;">


                <button class="btn_cart_check" id="confirm_btn" @click="confirmOrder()" style="display:none" ><i
                    class="fa fa-angle-right"></i> 
                        {{ $t("confirmOrder") }} </button>
            </div>
        </div>
    </div>
      <div v-if="errorMessage" style="
  position: fixed;
  z-index: 100;
  width: 320px;
  top: 10%;
  left: 50px;
  border-radius: 8px;
  background-color: white;
  border: 2px solid var(--primary-color);
  text-align: center;
  padding: 10px;
  color: black;
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
">

            <p style="margin-top: 10px;">{{ errorMessage }}</p>
        </div>
</div>

</template>

<script>
import item_cart from "../components/cart_item_order.vue";
import Vodal from "vodal";
import { HollowDotsSpinner } from "epic-spinners";

import "vodal/common.css";
import "vodal/slide-down.css";
import "vodal/flip.css";

export default {
    components: {
        HollowDotsSpinner,
        Vodal,
        item_cart,

    },
    data: function () {
        return {
            errorMessage: null,
            loading: true,
            user_name: null,
            phone: null,
            email: null,
            items: [],
            password: null,
            products: [],
            products_cost: [],
            loadingMethods: false,
            addresses: [],
            addAddress: false,
            showAddress: false,
            showMonthes: false,
            DBitems: null,
            discount_delivery_free: 0,
            selectPaymentType: null,
            selectDeliveryType: null,
            selectAddress: null,
            count_month: null,
            disCode: null,
            discount_id: null,
            PartialPrice: 0,
            discountPrice: 0,
            deliveryPrice: 0,
            totalPrice: 0,
            couponMsg: "",
            unit: this.$store.state.unit,
            allOrderNote: "",
            langChange: "",
            cities: [],
            countries: [],
            regions: [],
            city: null,
            region: null,
            street: null,
            building: null,
            street: null,
            other_details: null,
            show_guest: false,
            show_password: false,
            market_countries: [],
            country: 6,
            error_message:null,
        };
    },
    created() {

        if (this.$i18n.locale == 'ar') {
            this.unit = this.$store.state.unitAR;
        }
        else {
            this.unit = this.$store.state.unit;
        }

        //
        let AllCookies = this.$cookies.keys();
        this.items = [];
        this.products = [];
        this.products_cost = [];
        for (let i = 0; i < AllCookies.length; i++) {
            if (AllCookies[i].split("/")[0] == this.$store.storeName) {
                console.log('$$$$$$ ')

                this.items.push(AllCookies[i]);
                this.products.push(this.$cookies.get(AllCookies[i]));
                ////PartialPrice
                if (this.$cookies.get(AllCookies[i]).offer_price != 0) {
                    this.PartialPrice += this.$cookies.get(AllCookies[i]).offer_price;

                    console.log('$$$$$$ offer price ', i, '  ', this.PartialPrice)
                } else {

                    this.PartialPrice += this.$cookies.get(AllCookies[i]).total_price;
                    console.log('$$$$$$  total_price ', i, ' ', this.PartialPrice)
                }
                // console.log('products',pluck(this.products,"product_id"));
            }
        }
        for (let i = 0; i < this.products.length; i++) {
            this.products_cost.push(this.products[i]['product_id']);
        }
        console.log('product_cost: ', this.products_cost);


        this.loadingMethods = true;
        if (this.products_cost.length != 0) {
            this.axios
                .post(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/order/create/v2",
                    {
                        products: this.products_cost,
                    },
                    {

                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization:
                                "Bearer " + this.$localStorage.get(this.$store.storeName),
                        },
                    }
                )
                .then((response) => {
                    this.DBitems = response.data.data;
                })
                .then((this.loadingMethods = false))
                .catch((error) => {
                    if (error.response.status == "401") {

                    }
                });

        }

        this.axios
            .get(
                this.$store.state.base_api_url +
                this.$store.storeName +
                "/guest/addresses/create",
                {
                    headers: {
                        "Accept-Language": this.$i18n.locale,
                        Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
                    },
                }
            )
            .then((response) => {
                this.cities = response.data.data.cities;
                this.countries = response.data.data.countries;
            }).then();


        this.axios
            .get(
                this.$store.state.base_api_url + this.$store.storeName + "/market_countries",
                {
                    headers: {
                        "Accept-Language": this.$i18n.locale
                    }
                }
            )
            .then(response => {
                this.market_countries = response.data.data;
                console.log('gggg', this.countries)

            })
            .then(() => (this.loading = false));

    },
    watch: {
        langChange() {
            //  this.loading = false;
            if (this.$i18n.locale == 'ar') {
                this.unit = this.$store.state.unitAR;
            }
            else {
                this.unit = this.$store.state.unit;
            }
            //get profile

            //
            let AllCookies = this.$cookies.keys();
            this.items = [];
            this.products = [];
            this.products_cost = [];
            this.PartialPrice = 0;
            for (let i = 0; i < AllCookies.length; i++) {
                if (AllCookies[i].split("/")[0] == this.$store.storeName) {
                    this.items.push(AllCookies[i]);
                    this.products.push(this.$cookies.get(AllCookies[i]));
                    ////PartialPrice
                    if (this.$cookies.get(AllCookies[i]).offer_price != 0) {
                        this.PartialPrice += this.$cookies.get(AllCookies[i]).offer_price;
                    } else {
                        this.PartialPrice += this.$cookies.get(AllCookies[i]).total_price;
                    }
                    // console.log('products',pluck(this.products,"product_id"));
                }
            }

            for (let i = 0; i < this.products.length; i++) {
                this.products_cost.push(this.products[i]['product_id']);
            }
            console.log('product_cost: ', this.products_cost);


            ///////////methods
            this.loadingMethods = true;
            this.axios
                .post(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/order/create/v2",
                    { products: this.product_cost },
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization:
                                "Bearer " + this.$localStorage.get(this.$store.storeName),
                        },
                    }
                )
                .then((response) => {
                    this.DBitems = response.data.data;
                    // console.log(this.addresses);
                })
                .then((this.loadingMethods = false))
                .catch((error) => {
                    if (error.response.status == "401") {
                        this.$localStorage.remove(this.$store.storeName);
                        window.location.href = "/";
                    }
                });


            this.axios
                .get(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/guest/addresses/create",
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
                        },
                    }
                )
                .then((response) => {
                    this.cities = response.data.data.cities;
                    this.countries = response.data.data.countries;

                }).then(this.loading = false);


            this.axios
                .get(
                    this.$store.state.base_api_url + this.$store.storeName + "/market_countries",
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale
                        }
                    }
                )
                .then(response => {
                    this.market_countries = response.data.data;
                    console.log('gggg', this.countries)

                })
                .then(() => (this.loading = false));
        }
        ,
        PartialPrice() {
            //$store.state.tax
            //console.log("this.$store.state.tax "+ this.$store.state.tax + "  " +this.$store.state.tax+  this.PartialPrice)
            let x =
                this.PartialPrice -
                (this.discountPrice * this.PartialPrice) / 100 +
                this.deliveryPrice;
            this.totalPrice = x + (this.$store.state.tax * x) / 100;
            /*  let x= this.PartialPrice -( (this.discountPrice *  this.PartialPrice) / 100 );
                  this.totalPrice = x + ( (this.$store.state.tax *  x) / 100 ) +this.deliveryPrice;*/
            /* this.totalPrice =
                     this.PartialPrice -( (this.discountPrice *  this.PartialPrice) / 100 )+ this.deliveryPrice;
                   console.log("PartialPrice Change" + this.totalPrice);*/
        },
        discountPrice() {
            let x =
                this.PartialPrice -
                (this.discountPrice * this.PartialPrice) / 100 +
                this.deliveryPrice;
            this.totalPrice = x + (this.$store.state.tax * x) / 100;
            /* this.totalPrice =
                   this.PartialPrice -( (this.discountPrice *  this.PartialPrice) / 100 )+ this.deliveryPrice;
                   console.log("discountPrice Change" + this.totalPrice);*/
        },
        deliveryPrice() {
            let x =
                this.PartialPrice -
                (this.discountPrice * this.PartialPrice) / 100 +
                this.deliveryPrice;
            this.totalPrice = x + (this.$store.state.tax * x) / 100;
            /*  this.totalPrice =
                    this.PartialPrice -( (this.discountPrice *  this.PartialPrice) / 100 )+ this.deliveryPrice;
                    console.log("deliveryPrice Change" + this.totalPrice);*/
        },
        selectDeliveryType() {
            if (this.selectDeliveryType == 5) {
                this.showAddress = true;
                //console.log("this.showAddress" + this.showAddress);
            } else {
                this.showAddress = false;
            }
        },
        selectPaymentType() {
            if (this.selectPaymentType == 4) {
                this.showMonthes = true;
            } else {
                this.showMonthes = false;
                this.count_month = null;
            }
            //console.log( this.count_month)
        },
        city(newVal) {
            this.axios
                .get(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/guest/addresses/regions/" +
                    this.city,
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
                        },
                    }
                )
                .then((response) => {
                    this.regions = response.data.data.regions;
                    if (this.regions.find((o) => o.id == this.region) == null) {
                        this.region = null;
                    }
                });
        },

        region(newVal) {
            this.axios
                .post(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/guest/cost_delivery",
                    {
                        region_id: newVal,
                        delivery_id: 5,
                        cost: this.PartialPrice,
                        products: this.products_cost,
                    },
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
                        },
                    }
                )
                .then((response) => {
                    if (response.data.code == "1") {
                        if (this.discount_delivery_free == 0) {
                            // console.log(this.discount_delivery_free);
                            this.deliveryPrice = response.data.data.cost;
                        }
                        this.selectDeliveryType = 5// id;
                        //console.log(this.selectDeliveryType);
                        for (
                            let el = 0;
                            el < this.DBitems.delivery_type.types.length;
                            el++
                        ) {
                            this.DBitems.delivery_type.types[el].isActive = false;
                            if (this.DBitems.delivery_type.types[el].id == 5) {
                                this.DBitems.delivery_type.types[el].isActive = true;
                            }
                            //console.log(this.DBitems.delivery_type.types[el].isActive);
                        }
                        // this.discountPrice = response.data.data.discount;
                    } else {
                        alert(response.data.message);
                        this.selectAddress = null;

                        // const $select = document.querySelector("#addressSelect");
                        //$select.value = "SelectOne";
                    }
                    //this.addresses = response.data.data.addresses.addresses;
                    // console.log(this.addresses);
                })
                .then(() => {
                    this.loadingMethods = false;
                })
                .catch((error) => {
                    if (error.response.status == "401") {
                        //  this.$localStorage.remove(this.$store.storeName);
                        // window.location.href =
                        //   "/";
                    }
                });
        },

    },
    methods: {
        show_payment() {
        this.loadingMethods=true;
            var count_error = 0;
            var error_msg = "";
            if (this.user_name == null) {
                count_error++;
                document.getElementById('name').style = 'border:2px solid red !important'

                if (this.$i18n.locale == "ar") {
                    error_msg += (" يجب ادخال الاسم");
                } else {
                    error_msg += (" Please Enter Name");
                }
            }
            else {
                document.getElementById('name').style = 'border:2px solid #eaeff3'

            }

            if (this.phone == null) {
                count_error++;
                if (this.$i18n.locale == "ar") {
                    error_msg += (" يجب ادخال الهاتف");
                } else {
                    error_msg += (" Please Enter Phone");
                }
                document.getElementById('phone').style = 'border:2px solid red !important'
            }
            else {
                document.getElementById('phone').style = 'border:2px solid #eaeff3'

            }


            if (this.selectDeliveryType == null) {
                document.getElementById('delivery').style = 'color:red'

                count_error++;
                if (this.$i18n.locale == "ar") {
                    error_msg += (" يجب تحديد طريقة التوصيل");
                } else {
                    error_msg += (" Please select a delivery type");
                }
            }
            else {
                document.getElementById('delivery').style = 'color:black'
            }

            if (this.selectDeliveryType == 5 && this.region == null) {
                document.getElementById('region').style = 'border:2px solid red !important'

                count_error++;
                if (this.$i18n.locale == "ar") {
                    error_msg += ("يجب اختيار المنطقة ");
                } else {
                    error_msg += (" Please Select A Region");
                }
            }
            else {
                if(document.getElementById('region'))
                document.getElementById('region').style = 'border:2px solid #eaeff3'

            }




            if (count_error == 0) {
                this.loadingMethods = false;

                var element = document.getElementById('delivery_methods');
                var element_payment = document.getElementById('payment_methods')
                var payment_btn=document.getElementById('payment_btn')
                //confirm_btn
                var order_btn=document.getElementById('confirm_btn')



                element.style = "display:none";
                element_payment.style = "display:block";
                order_btn.style = "display:block";
                payment_btn.style="display:none"
            }
            else{
            this.loadingMethods=false}
        },
        show_delivery() {

            var count_error = 0;

            if (count_error == 0) {
                this.loadingMethods = false;

                var element = document.getElementById('delivery_methods');
                var element_payment = document.getElementById('payment_methods')
                var payment_btn=document.getElementById('payment_btn')

                element.style = "display:block";
                element_payment.style = "display:none";
                payment_btn.style="display:block"
            }

        },
        funshow_guest() {
            if (this.show_guest == false)
                this.show_guest = true;
            else
                this.show_guest = false;

        },
        close_address() {
            this.$store.state.addAddress = false;
        },
        open_address() {
            this.$store.state.addAddress = true;
        },
        updatAddress() {
            ///////////addresses
            this.loading = true;
            this.axios
                .get(
                    this.$store.state.base_api_url + this.$store.storeName + "/addresses",
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization:
                                "Bearer " + this.$localStorage.get(this.$store.storeName),
                        },
                    }
                )
                .then((response) => {
                    this.addresses = response.data.data.addresses.addresses;
                    /*if (this.addresses.length != 0) {
                      this.selectAddress = this.addresses[0].id;
                    }*/
                    // console.log(this.addresses);
                })
                .then((this.loading = false))
                .catch((error) => {
                    if (error.response.status == "401") {
                        this.$localStorage.remove(this.$store.storeName);
                        window.location.href =
                            "/";
                    }
                });
        },
        updatedata2() {
            console.log('jjjjjjjjjjjjjjjjjjjjjjjjjjjjjjj')
            this.langChange_check = false;
            this.langChange = false;
            ///////////methods
            this.loadingMethods = true;
            this.axios
                .post(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/order/create/v2",
                    { products: this.product_cost },
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization:
                                "Bearer " + this.$localStorage.get(this.$store.storeName),
                        },
                    }
                )
                .then((response) => {
                    this.DBitems = response.data.data;
                    // console.log(this.addresses);
                })
                .then((this.loadingMethods = false))
                .catch((error) => {
                    if (error.response.status == "401") {
                        this.$localStorage.remove(this.$store.storeName);
                        window.location.href = "/";
                    }
                });


            this.axios
                .get(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/guest/addresses/create",
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization: "Bearer " + this.$localStorage.get(this.$store.storeName),
                        },
                    }
                )
                .then((response) => {
                    this.cities = response.data.data.cities;
                }).then(this.loading = false);

        },
        Couponcode() {
            this.loading = true;
            this.axios
                .post(
                    this.$store.state.base_api_url +
                    this.$store.storeName +
                    "/guest/use_coupon",
                    {
                        code: this.disCode,
                        total_price: this.PartialPrice,
                    },
                    {
                        headers: {
                            "Accept-Language": this.$i18n.locale,
                            Authorization:
                                "Bearer " + this.$localStorage.get(this.$store.storeName),
                        },
                    }
                )
                .then((response) => {
                    if (response.data.code == "1") {
                        this.couponMsg = "";
                        this.discountPrice = response.data.data.discount;
                        this.discount_id = response.data.data.discount_id;
                        this.discount_delivery_free = response.data.data.isdelivery_free;
                        if (this.discount_delivery_free == 1)
                            this.deliveryPrice = 0;
                        /////////for select
                        // this.selectAddress = null;
                        // this.deliveryPrice = 0;
                        ////////////
                    } else {
                        this.couponMsg = response.data.message;
                        /////////for select
                        // this.selectAddress = null;
                        // this.deliveryPrice = 0;
                        ////////////
                    }
                    //this.addresses = response.data.data.addresses.addresses;
                    // console.log(this.addresses);
                })
                .then((this.loading = false))
                .catch((error) => {
                    if (error.response.status == "401") {
                        this.$localStorage.remove(this.$store.storeName);
                        window.location.href =
                            "/";
                    }
                });
        },
        selectPaymentTypeId(id) {
            document.getElementById('payment').style = "color:black";
            this.loadingMethods = true;
            this.selectPaymentType = id;
            //console.log(this.selectPaymentType);

            for (let el = 0; el < this.DBitems.payment_types.types.length; el++) {
                this.DBitems.payment_types.types[el].isActive = false;
                if (this.DBitems.payment_types.types[el].id == id) {
                    this.DBitems.payment_types.types[el].isActive = true;
                }
                //console.log(this.DBitems.payment_types.types[el].isActive);
            }

            //setTimeout(() => {
            this.loadingMethods = false;
            //  }, 3000);
        },
        selectDeliveryTypeId(id) {
            //  this.loadingMethods = true;
            console.log("bbbbbbbbbbbbbbbbbbb");
            this.selectDeliveryType = id;
            document.getElementById('delivery').style = "color:black";
            for (
                let el = 0;
                el < this.DBitems.delivery_type.types.length;
                el++
            ) {
                this.DBitems.delivery_type.types[el].isActive = false;
                if (this.DBitems.delivery_type.types[el].id == id) {
                    this.DBitems.delivery_type.types[el].isActive = true;
                }
                //console.log(this.DBitems.delivery_type.types[el].isActive);
            }
        },

        onChange: function (event) {
            this.selectAddress = event.target.value;
            this.selectDeliveryTypeId(5);
        },
        onChangeMonths: function (event) {
            //console.log( event.target.value)
            this.count_month = event.target.value;
        },
        confirmOrder() {
            this.change_state();
            document.getElementById("confirm_btn").disabled = true;
            var count_error = 0;
            var error_msg = "";

            if (this.selectPaymentType == null) {
                count_error++;
                document.getElementById('payment').style = 'color:red'

                if (this.$i18n.locale == "ar") {
                    error_msg += (" يجب تحديد طريقة الدفع");
                } else {
                    error_msg += ("Please select a payment type ");
                }
            }

            if (this.user_name == null) {
                count_error++;
                document.getElementById('name').style = 'border:2px solid red !important'

                if (this.$i18n.locale == "ar") {
                    error_msg += (" يجب ادخال الاسم");
                } else {
                    error_msg += (" Please Enter Name");
                }
            }

            if (this.selectDeliveryType == null) {
                document.getElementById('delivery').style = 'color:red'

                count_error++;
                if (this.$i18n.locale == "ar") {
                    error_msg += (" يجب تحديد طريقة التوصيل");
                } else {
                    error_msg += (" Please select a delivery type");
                }
            }

            if (this.selectDeliveryType == 5 && this.region == null) {
                document.getElementById('region').style = 'border:2px solid red !important'

                count_error++;
                if (this.$i18n.locale == "ar") {
                    error_msg += ("يجب اختيار المنطقة ");
                } else {
                    error_msg += (" Please Select A Region");
                }
            }



            if (this.phone == null) {
                count_error++;
                if (this.$i18n.locale == "ar") {
                    error_msg += (" يجب ادخال الهاتف");
                } else {
                    error_msg += (" Please Enter Phone");
                }
                document.getElementById('phone').style = 'border:2px solid red !important'
            }
            if (count_error == 0) {
                this.loading = true;
                this.axios
                    .post(
                        this.$store.state.base_api_url +
                        this.$store.storeName +
                        "/order/store/v2",
                        {

                            delivery_type_id: this.selectDeliveryType,
                            payment_type_id: this.selectPaymentType,
                            total_price: this.totalPrice,
                            discount_id: this.discount_id,
                            products: this.products,
                            part_price: this.PartialPrice,
                            note: this.allOrderNote,
                            count_month: this.count_month,
                            device: 'web',
                            user_name: this.user_name,
                            phone: this.phone,
                            email: this.email,
                            region_id: this.region,
                            street: this.street,
                            building: this.building,
                            other_details: this.other_details

                        },
                        {
                            headers: {
                                "Accept-Language": this.$i18n.locale,
                                Authorization:
                                    "Bearer " + this.$localStorage.get(this.$store.storeName),
                            },
                        }
                    )
                    .then((response) => {
                        if (response.data.code == "1") {
                            if (response.data.data.clear_cart == null || response.data.data.link_pay == null) {
                                for (let i = 0; i < this.items.length; i++) {
                                    this.$cookies.remove(this.items[i]);
                                }
                                this.items = [];

                                console.log("hiiiiiiii" + this.$cookies.keys());
                                this.$store.state.cartCounter = 0;
                            }

                            //console.log("hiiiiiiii" + this.$cookies.keys());

                            if (response.data.data.link_pay == null) {
                                this.$store.state.cartCounter = 0;
                                this.$router.push({
                                    name: "order_done",
                                    params: {
                                        storeName: this.$store.storeName,
                                        lang: this.$i18n.locale,
                                        id: response.data.data.order_id
                                    },
                                });
                            }

                            if (response.data.data.link_pay != null) {
                                window.location.href = response.data.data.link_pay;
                            }

                            //this.deliveryPrice = response.data.data.cost;
                            // this.discountPrice = response.data.data.discount;
                        } else {
                            alert(response.data.message);
                            document.getElementById("confirm_btn").disabled = false;
                            var count_error = 0;
                            var error_msg = "";
                            // this.couponMsg = response.data.message;
                        }
                        //this.addresses = response.data.data.addresses.addresses;
                        // console.log(this.addresses);
                    })
                    .then((this.loading = false))
                    .catch((error) => {
                        if (error.response.status == "401") {
                            this.$localStorage.remove(this.$store.storeName);
                            // window.location.href =
                            //   "/"+this.$i18n.locale ;
                        }
                    });
            }
            else {
                alert(error_msg);
                document.getElementById("confirm_btn").disabled = false;

            }


            //////////

            //////////

        },
        change_state() {
            document.getElementById('payment').style = "color:black";
            document.getElementById('delivery').style = "color:black";
            if (document.getElementById('region'))
                document.getElementById('region').style = "border: 0px solid var(--primary-color) !important;";
            document.getElementById('phone').style = "border: 0px solid var(--primary-color) !important;";
            document.getElementById('name').style = "border: 0px solid var(--primary-color) !important;";

        },
        funcreate_account_email() {
            console.log('11111111111')

            if (document.getElementById('account_email').checked == true)
                this.show_password = true;
            else
                this.show_password = false;
        },

        create_account() {

            var count_error = 0;
            var error_msg = "";
            document.getElementById('phone').style = "border: 0px solid #dde2e6 !important;";
            document.getElementById('name').style = "border: 0px solid #dde2e6 !important;";
            document.getElementById('email').style = "border: 0px solid #dde2e6 !important;";
            document.getElementById('password').style = "border: 0px solid #dde2e6 !important;";

            if (this.phone == null) {
                count_error++;
                document.getElementById('phone').style = 'border:2px solid red !important'


                if (this.$i18n.locale == "ar") {
                    error_msg += (" يجب إدخال الرقم");
                } else {
                    error_msg += ("Please Add Phone ");
                }
            }


            if (this.user_name == null) {
                count_error++;
                document.getElementById('name').style = 'border:2px solid red !important'


                if (this.$i18n.locale == "ar") {
                    error_msg += (" يجب إدخال الاسم");
                } else {
                    error_msg += ("Please Add User Name ");
                }
            }

            if (this.password == null) {
                count_error++;
                document.getElementById('password').style = 'border:2px solid red !important'


                if (this.$i18n.locale == "ar") {
                    error_msg += (" يجب إدخال كلمة السر");
                } else {
                    error_msg += ("Please Enter Password ");
                }
            }

            if (this.email == null) {
                count_error++;
                document.getElementById('email').style = 'border:2px solid red !important'


                if (this.$i18n.locale == "ar") {
                    error_msg += (" يجب إدخال الايميل");
                } else {
                    error_msg += ("Please Add Email");
                }
            }
            if (count_error == 0) {
                this.loading = true;
                console.log(this.phone)

                this.axios
                    .post(
                        this.$store.state.base_api_url +
                        this.$store.storeName +
                        "/register",
                        {
                            phone: this.$store.state.country_code + this.phone,
                            name: this.user_name,
                            email: this.email,
                            password: this.password

                        },

                        {

                            headers: {
                                "Accept-Language": this.$i18n.locale,
                            },
                        }
                    )
                    .then((response) => {
                        this.loading = false;

                        if (response.data.code == "1") {

                            this.$localStorage.set(
                                this.$store.storeName,
                                response.data.data.token
                            );
                            this.$localStorage.set(
                                this.$store.user_name,
                                response.data.data.name
                            );
                            if (!response.data.data.name || response.data.data.name == '') {
                                this.$localStorage.set(
                                    this.$store.user_name,
                                );
                            }
                            console.log(
                                this.$localStorage.get(this.$store.storeName) +
                                " id : " +
                                this.$store.storeName
                            );

                            console.log(
                                "user token : " +
                                this.$localStorage.get(this.$store.storeName)
                            );

                            window.location.href = '/checkout';
                            this.loading = false;
                        } else if (response.data.code == "-1") {
                            this.loading = false;
                            this.errorMessage = response.data.message;
                            setTimeout(() => {
                                this.errorMessage = "";
                                this.count_error = 0;
                            }, 3000);
                        }
                        if (response.data.error) {
                            this.errorMessage = "response.data.error";
                            setTimeout(() => {
                                this.errorMessage = "";
                            }, 3000);
                        }

                    });
            }
            else {
                alert(error_msg);
                setTimeout(() => {

                    var count_error = 0;
                    var error_msg = "";
                    document.getElementById('phone').style = "border: 0px solid #dde2e6 !important;";
                    document.getElementById('name').style = "border: 0px solid #dde2e6 !important;";
                    document.getElementById('email').style = "border: 0px solid #dde2e6 !important;";
                    document.getElementById('password').style = "border: 0px solid #dde2e6 !important;";
                }, 8000);
            }




        }
    },
};

</script>
